
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M20.4097 9C20.8997 9 21.0997 8.37 20.6997 8.09L13.1497 2.8C12.4597 2.32 11.5397 2.32 10.8597 2.8L3.29971 8.09C2.89971 8.37 3.09971 9 3.58971 9H10.9997V21C10.9997 21.55 11.4497 22 11.9997 22C12.5497 22 12.9997 21.55 12.9997 21V9H20.4097Z' fill='#323232'/><path d='M7.99994 16H4.89995L4.32994 12.98C4.22994 12.44 3.70994 12.08 3.15994 12.18C2.61994 12.28 2.25994 12.8 2.35994 13.35L2.99994 16.74V21C2.99994 21.55 3.44994 22 3.99994 22H4.00995C4.55995 22 5.00995 21.56 5.00995 21.01L5.01994 18H6.99994V21C6.99994 21.55 7.44994 22 7.99994 22C8.54994 22 8.99994 21.55 8.99994 21V17C8.99994 16.45 8.54994 16 7.99994 16Z' fill='#323232'/><path d='M20.84 12.18C20.3 12.08 19.78 12.44 19.67 12.98L19.1 16H16C15.45 16 15 16.45 15 17V21C15 21.55 15.45 22 16 22C16.55 22 17 21.55 17 21V18H18.98L19 21.01C19 21.56 19.45 22 20 22C20.55 22 21 21.55 21 21V16.74L21.64 13.35C21.74 12.81 21.38 12.28 20.84 12.18Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-deck`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconDeck

    ```js
    <b-new-b-icon-deck />
    ```
</docs>


